export default __webpack_public_path__ + "static/media/loading-bee02@4x.350407c0.jpeg";